import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgImageSliderComponent } from 'ng-image-slider';
import { CarrouselData } from 'src/app/domain/carrousel.model';
import { DomSanitizer } from '@angular/platform-browser';
import { EventsService } from 'src/app/services/dashboards/events.service';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import SwiperCore, { Navigation, Pagination, Thumbs } from 'swiper';
SwiperCore.use([Navigation, Thumbs]);
import Swiper from 'swiper';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'neoris-carousel-incident-record',
  templateUrl: './carousel-incident-record.component.html',
  styleUrls: ['./carousel-incident-record.component.css']
})
export class CarouselIncidentRecordComponent implements OnInit, AfterViewInit {

  @ViewChild('nav', { static: false }) slider: NgImageSliderComponent;
  private access_token: string = '';
  thumbsSwiper: any;
  mediaArray: { type: 'image' | 'video'; url: string }[] = [];
  @ViewChildren('slideEl') slideElements!: QueryList<ElementRef>;


  constructor(@Inject(MAT_DIALOG_DATA) public data: CarrouselData,
    private eventsService: EventsService,
    private breakpointObserver: BreakpointObserver,
    private controltowerservice: ControltowerService,
    private sanitizer: DomSanitizer) {
  }

  private swiper: any;
  private swiper2: any;
  @Output() rendered = new EventEmitter<void>();

  public showDetailSwiper: boolean = true

  ngAfterViewInit() {

         const isSmall = this.breakpointObserver.isMatched('(max-width: 426px)');


         if(isSmall){
          this.showDetailSwiper = false
         }

     this.slideElements.changes.subscribe(() => {
      if (this.slideElements.length > 0) {
        this.initSwipers();
      }
    });
    // this.rendered.emit();


    // Initialize Swiper after the view has been initialized

   

    //  new Swiper('.mySwiper', {
    //     loop: true,
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev'
    //     }
    //     ,
    //     pagination: {
    //       el: '.swiper-pagination',
    //       clickable: true
    //     }
    //   });
  }

  initSwipers() {
    console.log('initSwipers called');
    this.swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    this.swiper2 = new Swiper(".mySwiper2", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: this.swiper,
      },
    });

  this.swiper.slideTo(0, 0);
  this.swiper2.slideTo(0, 0);
  }

  private async GetAuthToken(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAuthIndustrialToken('storage_account', environment.authClientId).subscribe(
        {
          next: (data: any) => {

            this.access_token = data.access_token

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  allMediaReady(): boolean {
  return this.mediaArray.every(m => m.url !== null);
}

  async ngOnInit() {
    // const imageObject: Array<object> = []

    // var result = await this.GetAuthToken()
    const imageObject: Array<object> = []

    console.log("images", this.data.images)

    this.data.images.forEach(file => {
      console.log("ADDING ", file)
      let fileType = this.getFileType(file);

      if (fileType === 'video') {
        this.mediaArray.push({
          type: fileType,
          url: null
        });
      }

      if (fileType === 'image') {
        this.mediaArray.push({
          type: fileType,
          url: null
        });
      }
    })

    for (let index = 0; index < this.data.images.length; index++) {
      
      const file = this.data.images[index];
      console.log("complete ", file)
       this.eventsService.StreamingBlob(file, this.access_token).subscribe({
        next: (blob: Blob) => {

          let fileType = this.getFileType(file);
          if(fileType === 'video'){
            console.log("VIDEO FILE", file);
            const newBlob = new Blob([blob], { type: 'video/mp4' });
            const videoUrl = URL.createObjectURL(newBlob);//this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(newBlob));

             this.mediaArray[index].type = fileType
             this.mediaArray[index].url = videoUrl
          }

          if(fileType === 'image'){
             const blobUrl = URL.createObjectURL(blob);

             this.mediaArray[index].type = fileType
             this.mediaArray[index].url = blobUrl

            //  this.mediaArray.push({
            //   type: fileType,
            //   url: blobUrl
            // });
          }

          // const newBlob = new Blob([blob], { type: blob.type });
          // const blobUrl = URL.createObjectURL(blob);
          // // const isFirst = this.mediaArray.length === 0;
          // if (fileType === 'image' || fileType === 'video') {
          //   this.mediaArray.push({
          //     type: fileType,
          //     url: blobUrl
          //   });
          // }

          
          console.log('imageObject', imageObject);
        },
        error: () => {
          
          setTimeout(() => {
            //   this.mediaArray.push({
            //   type: 'image',
            //   url: null
            // });

            this.mediaArray[index].type = 'image'
            this.mediaArray[index].url = null

          }, 1000);
        
        }
      })
      
    }


    // this.data.images.forEach(file => {

    //   this.eventsService.StreamingBlob(file, this.access_token).subscribe({
    //     next: (blob: Blob) => {

    //       let fileType = this.getFileType(file);
    //       if(fileType === 'video'){
    //         console.log("VIDEO FILE", file);
    //         const newBlob = new Blob([blob], { type: 'video/mp4' });
    //         const videoUrl = URL.createObjectURL(newBlob);//this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(newBlob));

    //          this.mediaArray.push({
    //           type: fileType,
    //           url: videoUrl
    //         });
    //       }

    //       if(fileType === 'image'){
    //          const blobUrl = URL.createObjectURL(blob);

    //          this.mediaArray.push({
    //           type: fileType,
    //           url: blobUrl
    //         });
    //       }

    //       // const newBlob = new Blob([blob], { type: blob.type });
    //       // const blobUrl = URL.createObjectURL(blob);
    //       // // const isFirst = this.mediaArray.length === 0;
    //       // if (fileType === 'image' || fileType === 'video') {
    //       //   this.mediaArray.push({
    //       //     type: fileType,
    //       //     url: blobUrl
    //       //   });
    //       // }
    //       console.log('imageObject', imageObject);
    //     },
    //     error: () => {
          
    //       setTimeout(() => {
    //           this.mediaArray.push({
    //           type: 'image',
    //           url: null
    //         });
    //       }, 1000);
        
    //     }
    //   })

    // })

    this.imageObject = imageObject
  }

  getFileType(file: string): 'image' | 'video' | 'unknown' {
    const extension = file.split('.').pop()?.toLowerCase();

    if (!extension) return 'unknown';

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'webm'];

    if (imageExtensions.includes(extension)) return 'image';
    if (videoExtensions.includes(extension)) return 'video';

    return 'unknown';
  }



  imageObject: Array<object> = []

  public defaultActiveImage: number = 0
  public sliderNavClic(image: any) {
    const currentIndex: number = this.slider.visiableImageIndex
    const newIndex: number = image.index

    if (currentIndex < newIndex) {
      this.navigateToUp(newIndex)
    } else if (currentIndex > newIndex) {
      this.navigateToDown(newIndex)
    }
  }

  private newIndex: number = 0

  navigateToUp(newIndex: number) {
    this.newIndex = newIndex;
    this.recursiveSliderNext()
  }

  private recursiveSliderNext() {
    if (this.slider.visiableImageIndex < this.newIndex) {
      setTimeout(() => {
        this.slider.next();
        this.recursiveSliderNext()
      }, 50)
    }
  }

  private recursiveSliderPrev() {
    if (this.slider.visiableImageIndex > this.newIndex) {
      setTimeout(() => {
        this.slider.prev();
        this.recursiveSliderPrev()
      }, 50)
    }
  }

  navigateToDown(newIndex: number) {
    this.newIndex = newIndex;
    this.recursiveSliderPrev()
  }

  @ViewChild('video.clip-thumbnail') videoPlayer: ElementRef;


}
